import LocalStorage from 'Utils/localStorage';
import EnvironmentManager from 'Utils/environmentManager';
import { MULTIPLIER_VALID_MIN_VALUE_STATIC, MULTIPLIER_MAX_VALUE } from 'Store/constants';

const DEFAULT_STAKE_STORAGE_KEY = 'defaultStakeAmount';
const LAST_APPLIED_DEFAULT_STAKE_STORAGE_KEY = 'lastAppliedDefaultStakeAmount';

export const getDefaultStakeLimits = () => ({
  min: +EnvironmentManager.getParameter('TM_MIN_STAKE_WAGER_TMPRO') || MULTIPLIER_VALID_MIN_VALUE_STATIC,
  max: +EnvironmentManager.getMessageText({ key: 'TM_MAX_STAKE' }) || +MULTIPLIER_MAX_VALUE,
});

export const clampDefaultStakeAmount = rawValue => {
  const { min, max } = getDefaultStakeLimits();

  if (rawValue === '' || rawValue === null || rawValue === undefined) return min;

  const numericValue = Math.floor(+rawValue);

  if (Number.isNaN(numericValue) || numericValue < min) return min;
  if (numericValue > max) return max;

  return numericValue;
};

export const saveDefaultStakeAmount = amount => {
  const clampedAmount = clampDefaultStakeAmount(amount);

  LocalStorage.set(DEFAULT_STAKE_STORAGE_KEY, clampedAmount);
  LocalStorage.set(LAST_APPLIED_DEFAULT_STAKE_STORAGE_KEY, clampedAmount);
};

export const getLastAppliedDefaultStake = () => LocalStorage.get(LAST_APPLIED_DEFAULT_STAKE_STORAGE_KEY);

export const setLastAppliedDefaultStake = amount => {
  LocalStorage.set(LAST_APPLIED_DEFAULT_STAKE_STORAGE_KEY, amount);
};

export default function getDefaultStakeAmount () {
  const storedAmount = LocalStorage.get(DEFAULT_STAKE_STORAGE_KEY);

  return clampDefaultStakeAmount(storedAmount);
}
